import React from 'react';


const escapeSqlString = (str) => {
  return str.replace(/'/g, "''");
};
const escapeSqlString_current = (str) => {
    return str
      .replace(/\\/g, '\\\\')       // Escape backslashes
      .replace(/'/g, "\\'");        // Escape single quotes for SQL
  };
  
const wrapInBackticks = (str) => {
  if (str.startsWith('`') && str.endsWith('`')) return str; // already wrapped
  return `\`${str}\``;
};

const processExpressions1 = (expressions) => {
  const wrapped = {};
  for (const key in expressions) {
    wrapped[key] = wrapInBackticks(expressions[key]);
  }
  return JSON.stringify(wrapped).replace(/"/g, '\\"');
};

const processExpressions_current = (expressions) => {
    const wrapped = {};
    for (const key in expressions) {
      wrapped[key] = wrapInBackticks(expressions[key]);
    }
  
    return JSON.stringify(wrapped)
      .replace(/\\/g, '\\\\')    // Escape backslashes for SQL
      .replace(/'/g, "\\'");     // Escape single quotes for SQL
  };
  
  const processExpressions99 = (expressions) => {
    const cleaned = {};
    for (const key in expressions) {
      cleaned[key] = typeof expressions[key] === 'string'
        ? expressions[key].replace(/"/g, "'")
        : expressions[key];
    }
    return JSON.stringify(cleaned);
  };  
  const processExpressions = (expressions) => {
    const cleaned = {};
    for (const key in expressions) {
      if (typeof expressions[key] === 'string') {
        let value = expressions[key]
          .replace(/`/g, '') // Remove backticks
          .replace(/"/g, "'"); // Replace double quotes with single quotes
        if (key === 'nameHTML') {
          // Replace single quotes around <span and span> with escaped double quotes
          value = value
            .replace(/'<span/, '\\"<span')
            .replace(/span>'/, 'span>\\"');
        }
        cleaned[key] = value;
      } else {
        cleaned[key] = expressions[key];
      }
    }
    return JSON.stringify(cleaned);
  };
  

const SqlInsertGenerator = ({ templates, productType = 'windows' }) => {
  const generateSQL = () => {
    return templates.map((t) => {
      const id = escapeSqlString(t.id);
      const label = t.label ? `'${escapeSqlString(t.label)}'` : 'NULL';
      const description = t.description ? `'${escapeSqlString(t.description)}'` : 'NULL';
      //const condition = `'${escapeSqlString(/*wrapInBackticks*/(t.condition || 'true'))}'`;
      //const condition = `'${escapeSqlString(wrapInBackticks(t.condition || 'true'))}'`;
      const condition = `'${escapeSqlString(t.condition || 'true')}'`;

      const template = `'${escapeSqlString(t.template)}'`;
      //const expressions = `"${processExpressions(t.expressions || {})}"`;
      const expressions = `'${escapeSqlString(processExpressions(t.expressions || {}))}'`;


      const active = t.active ? 1 : 0;
      const orderPlace = t.orderPlace || 0;

      return `INSERT INTO AppearanceTemplates (\`id\`, \`product_type\`, \`label\`, \`description\`, \`condition\`, \`template\`, \`expressions\`, \`active\`, \`order_place\`)
VALUES ('${id}', '${productType}', ${label}, ${description}, ${condition}, ${template}, ${expressions}, ${active}, ${orderPlace})
ON DUPLICATE KEY UPDATE
  \`product_type\`='${productType}',
  \`label\`=${label},
  \`description\`=${description},
  \`condition\`=${condition},
  \`template\`=${template},
  \`expressions\`=${expressions},
  \`active\`=${active},
  \`order_place\`=${orderPlace};`;
    }).join('\n\n');
  };

  return (
    <div>
      <h3>Generated SQL:</h3>
      <pre style={{ whiteSpace: 'pre-wrap', fontSize: '12px' }}>
        {generateSQL()}
      </pre>
    </div>
  );
};

export default SqlInsertGenerator;
